export const PANEL_HOME_PAGE_TEXT = {
  TITLE: 'Panel',
  HOME_PAGE: 'Panel List',
  PANEL_NAME: 'Panel Name: ',
  PANEL_ROUND: 'Panel Round',
  DUE: 'Due',
  PANEL_SELECTION_LIST: 'Panel Selection List',
  HOME: 'Home',
  START_TIME: 'Start Time: ',
  END_TIME: 'End Time: ',
  PANEL_MEETING_TIME: 'Panel Meeting Date: ',
  DISCIPLINE: 'Discipline: ',
  APPLICATION_REVIEW: 'Review Assigned Applications',
};
